import script from "./BScrollBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BScrollBox.vue?vue&type=script&setup=true&lang=js"

import "./BScrollBox.vue?vue&type=style&index=0&id=71adf939&lang=scss"

const __exports__ = script;

export default __exports__